<template>
	<div class='text'>
		A new public deal at <DealComponent :notification='notification' /> was added by <UserComponent :notification='notification' />
	</div>
</template>

<script>
import UserComponent from '../UserComponent/UserComponent.vue';
import DealComponent from '../DealComponent/DealComponent.vue';
export default {
	name:       'NewPublicDealsText',
	components: {
		UserComponent,
		DealComponent
	},
	props: {
		notification: {
			type: Object
		}
	}
};
</script>
